import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useProperties } from '@/hooks/data/useProperties';
import { PropertiesTable } from './properties';

export const Route = createFileRoute('/_app/properties/active')({
  component: PropertiesActivePage,
});

function PropertiesActivePage() {
  const { t } = useTranslation();
  const { data: items = [], isLoading, error } = useProperties({ marketingStage: 'active' });

  return (
    <section className="space-y-6">
      <header>
        <h2 className="text-2xl font-semibold tracking-tight">
          {t('properties.active.title', 'Aktive Immobilien')}
        </h2>
        <p className="text-sm text-muted-foreground">
          {t(
            'properties.active.subtitle',
            'Aktiv vermarktete Objekte. Buyer-Matching wird automatisch ausgeführt.',
          )}
        </p>
      </header>
      <PropertiesTable items={items} loading={isLoading} error={error as Error | null} />
    </section>
  );
}
